import React from 'react';
import styles from './image-skeleton.module.scss';
interface Props {}

const ImageSkeleton = (props: Props) => {
    return <div className={styles.imageSkeleton}></div>;
};

export default ImageSkeleton;
